module.exports = __webpack_public_path__ + "img/gb119-86-d4x8.prt.caaf4d79.jpg";